import { TFunction } from "i18next";
import { SubscriptionCreationForm } from "../../domain/models/dto/SubscriptionDTO";
import { Fields } from "../../types/SchemaFactory";
import { schemaFactory } from "../SchemaFactory";
import { getMaxEnumValue } from "../../tools/EnumTools";
import { SubscriptionType } from "../../domain/enums/SubscriptionTypeEnum";
import { PaymentMethod } from "../../domain/enums/PaymentMethodEnum";

export const subscriptionCreationFields: Fields<SubscriptionCreationForm> = {
    type: {
        min: 1,
        max: getMaxEnumValue(SubscriptionType),
        required: true,
        placeholderKey: "",
        type: "number",
        initial: SubscriptionType.COMMON,
    },
    paymentMethod: {
        min: 1,
        max: getMaxEnumValue(PaymentMethod),
        required: false,
        placeholderKey: "subscription.paymentMethodTitle",
        type: "number",
        initial: PaymentMethod.EASY_PAY,
    },
    autoActivation: {
        min: 0,
        max: 1,
        required: true,
        placeholderKey: "subscription.autoContinue",
        type: "boolean",
        initial: false,
    },
    consent: {
        min: 0,
        max: 1,
        required: true,
        placeholderKey: "subscription.consent",
        type: "boolean",
        initial: false,
    },
};

export const subscriptionsCreationSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, subscriptionCreationFields);
};
